export default __webpack_public_path__ + "static/media/discovery.c65af0fb.svg";